import { Carousel } from "primereact/carousel";
import Product from "./Product";

export function ProductCarousel({ data }) {
    const itemTemplate = (id) => {
        return <Product id={id} />;
    };
    return (
        <Carousel
            value={data}
            itemTemplate={itemTemplate}
            numVisible={1}
            numScroll={1}
            className="custom-carousel"
            autoplayInterval={3000}
        />
    );
}
